import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Favorites } from "@/components/widgets/controlPanel/favorites/favorites";
import { Blacklist } from "@/components/widgets/controlPanel/blacklist/blacklist";
import { GlobalFilters } from "@/components/widgets/controlPanel/globalFilters/globalFilters";
import { AlertHistory } from "@/components/widgets/controlPanel/alerts-history/alerts-history";
import { useDashboard } from "@/lib/store";
import { hasAccessToWidget } from "@/domain/constants";
import { usePaneContext } from "@/components/pane/paneContext";
import { EWidgetType } from "@/domain/enums/dashboard.enum";
import { useGrid } from "@/hooks/useGrid";
import { useMarketplaceStore } from "@/lib/stores/useMarketplaceStore";
import { useUserStore } from "@/lib/stores/userStore";

export function ControlPanel() {
  const { globalFilters, blacklist } = useDashboard((state) => ({
    globalFilters: state.globalFilters,
    blacklist: state.blacklist,
  }));
  const nodeId = usePaneContext();
  const { node, getNodeConfig } = useGrid(nodeId);
  const widgetType = node?.getComponent() as EWidgetType;
  const config = getNodeConfig();
  const { user } = useUserStore();
  const { purchasedProductIds } = useMarketplaceStore();

  if (
    !hasAccessToWidget(user?.role || "GUEST", widgetType, purchasedProductIds)
  ) {
    return (
      <div className="flex flex-col h-[calc(100%)] items-center justify-center">
        <div className="text-xs">
          Upgrade your plan to {config?.plan} use this feature
        </div>
      </div>
    );
  }
  return (
    <Tabs defaultValue="favorites" className="p-1 h-[calc(100%-48px)]">
      <TabsList className="123 grid grid-cols-6 bg-neutral-950 gap-1">
        <TabsTrigger
          className="text-xs text-white border border-neutral-800 uppercase data-[state=active]:bg-white data-[state=active]:text-black"
          value="favorites"
        >
          Favorites
        </TabsTrigger>
        <TabsTrigger
          className="text-xs text-white border border-neutral-800 uppercase data-[state=active]:bg-white data-[state=active]:text-black relative"
          value="blacklist"
        >
          BlackList
          {blacklist.length > 0 && (
            <div className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full" />
          )}
        </TabsTrigger>
        <TabsTrigger
          className="text-xs text-white border border-neutral-800 uppercase data-[state=active]:bg-white data-[state=active]:text-black relative"
          value="globalFilters"
        >
          Filters
          {globalFilters.length > 0 && (
            <div className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full" />
          )}
        </TabsTrigger>
        <TabsTrigger
          className="text-xs text-white border border-neutral-800 uppercase data-[state=active]:bg-white data-[state=active]:text-black"
          value="alerts-history"
        >
          Alerts
        </TabsTrigger>
      </TabsList>
      <TabsContent value="favorites" className="h-full">
        <Favorites />
      </TabsContent>
      <TabsContent value="blacklist" className="h-full">
        <Blacklist />
      </TabsContent>
      <TabsContent value="globalFilters" className="h-full">
        <GlobalFilters />
      </TabsContent>
      <TabsContent value="alerts-history" className="h-full">
        <AlertHistory />
      </TabsContent>
    </Tabs>
  );
}
